module.exports = __webpack_public_path__ + "static/img/dominio-zona-dns-registro-br@2x.b151f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/dominio-zona-dns-registro-br@2x.png
// module id = 1681
// module chunks = 5